import { Link } from "react-router-dom";
import footerlogo from "../images/footerlogo.png";
import phoneIcon from "../images/call.png";
import emailIcon from "../images/massage.png";
import locationIcon from "../images/location.png";
import facebookIcon from "../images/facebookicon.png";
import instagramIcon from "../images/instagram.png";
import telegramIcon from "../images/telegram.png";
import twitterIcon from "../images/twiter.png";
import snapchatIcon from "../images/snapchat.png";

const Footer = () => {
  return (
    <footer className="bg-[#56C7D5] text-white font-poppins">

      <div className="max-w-7xl mx-auto px-8 lg:px-0 pt-16 pb-20">

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-20 items-start">

          {/* Logo + about */}
          <div className="md:col-span-5">
            <img src={footerlogo} alt="Logo" className="h-12 mb-6 object-contain" />

            <p className="text-[16px] leading-relaxed text-white/90 mb-8 max-w-[380px]">
              Slimming Doctor is regulated by the Care Quality Commission (CQC).
              We comply with the best practices outlined by the CQC which
              guarantees that you receive the highest level of care from us.
            </p>

            <div className="space-y-3 text-[16px] text-white/90">
              <div className="flex items-center gap-3">
                <img src={phoneIcon} alt="phone" className="h-5 w-5" />
                <span>0208 617 3850</span>
              </div>

              <div className="flex items-center gap-3">
                <img src={emailIcon} alt="email" className="h-5 w-5" />
                <span>contactus@slimmingdoctor.co.uk</span>
              </div>

              <div className="flex items-start gap-3">
                <img src={locationIcon} alt="location" className="h-5 w-5 mt-1" />
                <span>249A Station Road Harrow HA1 2TB</span>
              </div>
            </div>
          </div>

          {/* Company Links (ALL React Router Links) */}
          <div className="md:col-span-2">
            <h3 className="font-bold text-[24px] mb-3">Company</h3>
            <ul className="space-y-2 text-[16px] text-white/90 leading-[45px]">
              <li><Link to="/">Home</Link></li>
              <li><Link to="#">Treatment</Link></li>
              <li><Link to="/components/pricing">Prices</Link></li>
              <li><Link to="./components/about-us">About Us</Link></li>
            </ul>
          </div>

          {/* Support Links */}
          <div className="md:col-span-2">
            <h3 className="font-bold text-[24px] mb-3">Support</h3>
            <ul className="space-y-2 text-[16px] text-white/90 leading-[45px]">
              <li><Link to="/faqs">FAQ&apos;s</Link></li>
              <li><Link to="#">Contact Us</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Social Icons (External → use <a>) */}
          <div className="md:col-span-3">
            <h3 className="font-bold text-[24px] mb-4">Follow us</h3>

            <div className="flex gap-4">

              {/* Left Column */}
              <div className="flex flex-col gap-4">
                {[
                  { icon: facebookIcon, href: "https://facebook.com" },
                  { icon: telegramIcon, href: "https://telegram.org" },
                  { icon: snapchatIcon, href: "https://snapchat.com" }
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-10 w-10 bg-white rounded-full flex items-center justify-center shadow-[0_2px_6px_rgba(0,0,0,0.15)]"
                  >
                    <img src={item.icon} className="h-5 w-5" />
                  </a>
                ))}
              </div>

              {/* Right Column */}
              <div className="flex flex-col gap-4">
                {[
                  { icon: instagramIcon, href: "https://instagram.com" },
                  { icon: twitterIcon, href: "https://twitter.com" }
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="h-10 w-10 bg-white rounded-full flex items-center justify-center shadow-[0_2px_6px_rgba(0,0,0,0.15)]"
                  >
                    <img src={item.icon} className="object-contain max-h-6 max-w-6" />

                  </a>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-[#51C2D0]">
        <div className="max-w-7xl mx-auto px-8 py-4 flex flex-col md:flex-row items-center justify-between text-[16px] text-white/90 gap-3">
          <p>© 2024 – Slimming Doctor. All Rights Reserved.</p>

          <button className="flex items-center gap-2">
            <img src={require("../images/global.png")} className="h-5 w-5" />
            English
            <span className="text-xs">▼</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
